module.exports = __webpack_public_path__ + "img/pgd_a_11111.53270282.png";